// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__S7YMm","mobile":"style_mobile__oHDuU","laptop":"style_laptop__fYrLv","v3":"style_v3__B5GXG"};